import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Application } from '../models/application';
import { SecurityApiService } from './api/security-api.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationsListService {
    private security = inject(SecurityApiService);

    /**
     * Return the application with the corresponding code if it is accessible by the current user
     * @param code Code of the application you're looking for
     */
    public getAccessibleApplication(code: string): Observable<Application | undefined> {
        return this.security.getAccessibleApplications().pipe(map((data) => data.find((app) => app.code === code)));
    }
}
